import React from 'react';
import Contact from '../Components/ContactComponent/Contact';
import Header from '../Components/GlobalComponent/Header';
import Footer from '../Components/GlobalComponent/Footer';
import Banner from '../Components/AboutComponent/Banner';
import About from '../Components/AboutComponent/About';
import Team from '../Components/AboutComponent/Team';

const AboutUs = () => {
    return (
        <div>
            <Header/>
            <Banner/>
            <About/>
            <Team/>
            <Footer/>
        </div>
    );
};

export default AboutUs;
